import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import {
  CREATE_RATING,
  FILTER_PRODUCTS,
  GET_DETAILS,
  GET_PREVIOUS_ORDER,
  GET_RECENT_VIEW_PRODUCT,
  GET_SORT_DATA,
  GET_SUBSTITUTE_PRODUCT,
  ITEM_RATING_DETAILS,
  ITEM_RATING_REVIEW_DETAILS,
  STORE_VIEW_PRODUCT,
} from "../routes";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery,
  endpoints: (builder) => ({
    product: builder.query({
      query: (filters) => ({
        url: FILTER_PRODUCTS,
        params: filters,
      }),
      transformResponse: (response: ApiResponseProductLists) => {
        return response;
      },
    }),
    getItemRating: builder.query({
      query: (id) => ({
        url: `${ITEM_RATING_DETAILS}/${id}`,
      }),
      transformResponse: (response: ApiResponse<ProductReviewStats>) => {
        return response?.rating_details;
      },
    }),
    getItemReviewDatails: builder.query({
      query: ({ id, rating }: { id: number; rating?: number }) => ({
        url: `${ITEM_RATING_REVIEW_DETAILS}/${id}`,
        params: { rating },
      }),
      transformResponse: (response: ApiResponse<ReviewDetailTypes[]>) => {
        return response?.review_details;
      },
    }),
    getSortData: builder.query({
      query: () => GET_SORT_DATA,
      transformResponse: (response: ApiResponse<sortOptionTypes[]>) => {
        return response?.data;
      },
    }),
    getProductDetails: builder.query({
      query: (data) => ({
        url: GET_DETAILS,
        params: {
          q: data?.q,
          attribute_id: data?.attribute_id ? data?.attribute_id : undefined,
        },
      }),
      transformResponse: (response: ProductDetailsResponse) => {
        return response;
      },
    }),
    getRecentViewProduct: builder.query({
      query: ({unique_id, user_id}: { unique_id: string; user_id?: number }) => ({
        url: GET_RECENT_VIEW_PRODUCT,
        params: { unique_id: unique_id, user_id: user_id ? user_id : undefined },
      }),
      transformResponse: (response: ApiResponse<MedicineTypes[]>) => {
        return response?.data;
      },
    }),
    getSubstituteProduct: builder.query({
      query: ({composition, product_id}: { composition: string; product_id: string }) => ({
        url: GET_SUBSTITUTE_PRODUCT,
        params: { composition, product_id },
      }),
      transformResponse: (response: ApiResponse<MedicineTypes[]>) => {
        return response?.data;
      },
    }),
    getPreviousOrder: builder.query({
      query: (customer_id) => ({
        url: GET_PREVIOUS_ORDER,
        params: { customer_id },
      }),
      transformResponse: (response: ApiResponse<MedicineTypes[]>) => {
        return response?.data;
      },
    }),
    storeViewProduct: builder.mutation({
      query: (credentials) => ({
        url: STORE_VIEW_PRODUCT,
        method: "POST",
        body: credentials,
      }),
    }),
    writeReview: builder.mutation({
      query: (credentials) => ({
        url: CREATE_RATING,
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const {
  useLazyProductQuery,
  useGetSortDataQuery,
  useLazyGetProductDetailsQuery,
  useStoreViewProductMutation,
  useGetRecentViewProductQuery,
  useLazyGetPreviousOrderQuery,
  useLazyGetItemRatingQuery,
  useLazyGetItemReviewDatailsQuery,
  useWriteReviewMutation,
  useLazyGetSubstituteProductQuery
} = productApi;
